import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'
import { fetchNewPartnerById } from 'legacy/lut/services/partner/fetchNewPartnerById'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { GET_NEW_PARTNER_BY_ID_REQUEST } from '../configs'
import { selectPartnerData } from '../selectors'

export const getNewPartnerById = createAsyncThunk(
  GET_NEW_PARTNER_BY_ID_REQUEST,
  async ({ partnerId, options }: IRequestByPartnerId) => fetchNewPartnerById(partnerId, options),
  {
    condition({ partnerId, options }, { getState }) {
      if (!partnerId) {
        return false
      }

      const state = getState()
      const partnerData = selectPartnerData(state)

      if (partnerData.status === RequestStatus.PENDING) {
        return false
      }

      if (partnerData.data?.partnerId === partnerId && !options?.isForce) {
        return false
      }

      return true
    },
  }
)
